/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core';

const ForgotPasswordFormStyles = makeStyles((theme: Theme) =>
	createStyles({
		circularProgress: {
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
		},
		separator: {
			fontFamily: theme.typography.fontFamilyBold,
			color: theme.palette.grey['700'],
			marginTop: theme.spacing(10),
			marginBottom: theme.spacing(4),
			fontSize: '0.9rem',
			display: 'flex',
			flexDirection: 'row',
			'&::before, &::after': {
				content: '""',
				flex: '1 1',
				borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
				margin: 'auto',
			},
			'&::before': {
				marginRight: theme.spacing(3),
			},
			'&::after': {
				marginLeft: theme.spacing(3),
			},
		},
		resetTitle: {
			color: theme.palette.grey['700'],
			marginBottom: '40px',
		},
		formRoot: {
			paddingLeft: theme.spacing(6),
			paddingRight: theme.spacing(6),
			'& > *': {
				marginBottom: theme.spacing(3),
				width: '100%',
			},
		},
		label: {
			marginBottom: 2,
			fontSize: 'small',
			fontFamily: theme.typography.fontFamilyBold,
			color: theme.palette.common.black,
		},
		submitButton: {
			right: 0,
			maxWidth: '45%',
		},
		cancelContainer: {
			marginTop: '80px',
			display: 'flex',
			justifyContent: 'center',
		},
		cancelButton: {
			padding: 0,
			height: '24px',
			width: '24px',
		},
		cancelText: {
			paddingLeft: '10px',
			lineHeight: '24px',
			color: theme.palette.grey['700'],
			textDecoration: 'underline',
			fontFamily: theme.typography.fontFamilyBold,
			cursor: 'pointer',
			'&:hover': {
				color: theme.palette.grey['800'],
			},
		},
	})
);

export default ForgotPasswordFormStyles;
